import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Button, List, Table } from 'antd'

import Details from './Details'

@inject((store: any) => {
    const { popupStore, recordsStore } = store
    return { popupStore, recordsStore }
})
@observer
export default class RecordsPopup extends Component<any, any> {
    state: any = {
        errors: {}
    }

    closePopup = () => {
        this.props.recordsStore.resetRecords()
        this.props.popupStore.togglePopup(false)
    }
    render() {
        const { popupStore, recordsStore } = this.props
        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                <Button onClick={this.closePopup}>סגור</Button>
            </div>
        )

        const columns = [
            {
                title: 'תנאים',
                key: 'terms_and_conditions',
                align: 'right',
                render: (_, record) => {
                    return <Details {...record} />
                }
            }
        ]

        return (
            <Modal
                title={'תנאים והגבלות'}
                visible={popupStore.popupType === 'records'}
                cancelText="ביטול"
                onCancel={this.closePopup}
                footer={footerButtons}
            >
                <label htmlFor="type">
                    <strong>התנאים וההגבלות תחת זכות</strong>
                </label>
                <Table
                    className="center-table"
                    style={{ width: '100%' }}
                    rowKey="id"
                    pagination={{ pageSize: 5 }}
                    columns={columns}
                    dataSource={recordsStore.list}
                />
            </Modal>
        )
    }
}
